const config ={
    baseUrl:'',
}

if (typeof window !== "undefined") {
    window.bootstrapConfigSettings = config;
}